import React, { Component } from "react";

import {
  Button,
  Card,
  Col,
  Divider,
  Icon,
  Modal,
  Row,
  Table,
  Tooltip,
} from "antd";

import axios from "axios";
import { connect } from "react-redux";
// import Admin from '../Admin/Admin';
import AddPartnerLocationModal from "./AddPartnerLocationModal";
import "./Partners.css";

const { Meta } = Card;
const { Column, ColumnGroup } = Table;
const { confirm } = Modal;
class Partner extends Component {
  state = {
    info: "",
    loading: false,
    contactInfo: {},
    addLocationModal: "",
    addLocation: false,
    locationInfo: [],
  };

  componentDidMount = () => {
    const { match } = this.props;

    const { id } = match.params;

    this.setState({ loading: true });
    axios({
      method: "get",
      url: `/partners/${id}.json`,
      headers: { Authorization: sessionStorage.getItem("jwtToken") },
    })
      .then((response) => {
        this.setState({
          info: response.data,
          contactInfo: response.data.partner_contacts, // CONTACT OF MAIN PERSON
          loading: false,
        });
      })
      .catch((error) => {
        alert(`${error}: ${error.code}`);
      });
    axios({
      method: "get",
      url: `/partner_locations.json?partner_id=${id}`,
      headers: { Authorization: sessionStorage.getItem("jwtToken") },
    }).then((response) => {
      console.log(response.data);
      this.setState({ locationInfo: response.data });
    });
  };

  showDeleteConfirm = (id) => {
    const { locationInfo } = this.state;

    confirm({
      title: "Are you sure delete this Location?",
      content: "This cannot be undone.",
      okText: "Yes",
      okType: "danger",
      cancelText: "No",
      onOk: () => {
        axios({
          method: "delete",
          url: `/partner_locations/${id}.json`,
          headers: { Authorization: sessionStorage.getItem("jwtToken") },
        }).then((response) => {
          const newLocations = locationInfo.filter(
            (location) => location.id !== id
          );
          console.log(response, "response here");
          this.setState({ locationInfo: newLocations });
          // window.location.reload();
        });
      },
      onCancel: () => console.log("Cancel"),
    });
  };

  goBack = () => {
    const { history } = this.props;
    history.goBack();
  };

  showAddLocationModal = () => {
    this.setState({ addLocationModal: true });
  };

  handleCancelLocationModal = () => {
    this.setState({ addLocationModal: false });
  };

  saveFormRef = (formRef) => {
    this.formRef = formRef;
  };

  handleCreateAddLocationModal = () => {
    const { match } = this.props;
    const { form } = this.formRef.props;
    // console.log(form);
    form.validateFields((err, values) => {
      if (err) {
        return;
      }

      const info = {
        partner_location: {
          name: values.name,
          partner_id: match.params.id,
          address: {
            address_name: values.address_name,
            line_1: values.line_1,
            city: values.city,
          },
          partner_contacts: [
            {
              name: values.name,
              email: values.email,
              mobile_number: String(values.mobile_number),
            },
          ],
        },
      };
      this.setState({ addLocation: true });
      axios({
        method: "post",
        url: "/partner_locations.json",
        data: info,
        headers: { Authorization: sessionStorage.getItem("jwtToken") },
      })
        .then((response) => {
          console.log(response.data);
          this.setState({ addLocation: false });
          form.resetFields();
          this.handleCancelLocationModal();
          window.location.reload();
        })
        .catch((error) => {
          alert(error.code);
          this.setState({ addLocation: false });
        });
    });
  };

  render() {
    const {
      loading,
      info,
      contactInfo,
      locationInfo,
      addLocationModal,
      addLocation,
    } = this.state;

    return (
      <Card
        extra={
          <Button type="primary" onClick={() => this.goBack()}>
            <Icon type="left" />
            Go back
          </Button>
        }
        title="Partner Details"
        loading={loading}
        bordered
        style={{
          width: "70%",
          minHeight: "500px",
          margin: "auto",
          textAlign: "center",
          boxShadow: " 3px 3px 5px 6px #ccc",
        }}
      >
        <Row type="flex" justify="space-around" align="middle">
          <Col className="mb-2" span={8}>
            <p className="text-sm-left h5">Name</p>
            <input
              disabled
              defaultValue={info.name}
              className="form-control text-sm-left"
            />
          </Col>

          <Col className="mb-2" span={8}>
            <p className="text-sm-left h5 ">Type</p>
            <input
              disabled
              defaultValue={info.partner_type}
              className="form-control text-sm-left"
            />
          </Col>

          <Col className="mb-2" span={20}>
            <p className="text-sm-left h5">Address</p>
            <input
              disabled
              defaultValue={
                info
                  ? `${info.name} ${info.address.name}, ${info.address.line_1}, ${info.address.city}`
                  : null
              }
              className="form-control text-sm-left"
            />
          </Col>

          <Col className="mb-2" span={8}>
            <p className="text-sm-left h5">State</p>
            <input
              disabled
              defaultValue={info ? info.address.state : null}
              className="form-control text-sm-left"
            />
          </Col>

          <Col className="mb-2" span={8}>
            <p className="text-sm-left h5">Pincode</p>
            <input
              disabled
              defaultValue={info ? info.address.pin_code : null}
              className="form-control text-sm-left"
            />
          </Col>
        </Row>

        <hr />

        <Meta className="mb-2" title="Contact Information" />

        <Table pagination={false} dataSource={info ? contactInfo : null}>
          <Column title="Name" dataIndex="name" key="name" />
          <Column title="Email Address" dataIndex="email" key="email" />
          <Column
            title="Mobile Number"
            dataIndex="mobile_number"
            key="mobile_number"
          />
        </Table>

        <br />
        <br />
        <Meta className="mb-2" title="Location Information" />

        <Table bordered pagination={false} dataSource={locationInfo || null}>
          <Column title="Name" dataIndex="name" key="name" />

          <ColumnGroup title="Contact Info">
            <Column
              title="Contact Name"
              dataIndex="partner_contacts"
              key="id"
              render={(contact) => `${contact[0].name}`}
            />
            <Column
              title="Mobile Number"
              dataIndex="partner_contacts"
              key="id"
              render={(contact) => `${contact[0].mobile_number}`}
            />
            <Column
              title="Email"
              dataIndex="partner_contacts"
              key="id"
              render={(contact) => `${contact[0].email}`}
            />
          </ColumnGroup>

          <Column
            title="Actions"
            key="id"
            render={(record) => (
              <span>
                <Tooltip placement="top" title="Edit">
                  <span
                    onClick={() => this.handlePartnerClick(record.id)}
                    role="button"
                  >
                    <a>
                      <Icon type="edit" />
                    </a>
                  </span>
                </Tooltip>
                <Divider type="vertical" />
                <Tooltip placement="top" title="Delete">
                  <span
                    onClick={() => this.showDeleteConfirm(record.id)}
                    role="button"
                  >
                    <a>
                      <Icon type="close-circle" style={{ color: "red" }} />
                    </a>
                  </span>
                </Tooltip>
              </span>
            )}
          />
        </Table>

        <br />
        <br />

        <Row type="flex" justify="center" gutter={30}>
          <Col>
            <Button type="primary"> Edit info </Button>
          </Col>

          <Col>
            <Button type="danger"> Delete </Button>
          </Col>

          <Col>
            <Button type="primary" onClick={this.showAddLocationModal}>
              Add Location
            </Button>
            <AddPartnerLocationModal
              visible={addLocationModal}
              wrappedComponentRef={this.saveFormRef}
              onCancel={this.handleCancelLocationModal}
              onCreate={this.handleCreateAddLocationModal}
              confirmLoading={addLocation}
            />
          </Col>
        </Row>
      </Card>
    );
  }
}

const mapStateToProps = (state) => ({
  token: state.AppState.token,
  loggedIn: state.AppState.loggedIn,
});

export default connect(mapStateToProps, null)(Partner);



// WEBPACK FOOTER //
// ./src/component/Partners/Partners.js